<div class="row">
    <div class="col-lg-6 col-lg-offset-2">
        <div class="panel">
            <div class="panel-content" style="padding-top: 20px; padding-bottom: 20px;">
                <div class="account-wall" style="text-align: center;">
                    <div class="login-text">AUTENTICAZIONE</div>
                    <form class="form-signin" (ngSubmit)="onSubmit()" #loginForm="ngForm">
                        <div class="append-icon">
                            <input type="text" class="form-control input-lg" id="username"
                                   required autocomplete="off"
                                   placeholder="Username"
                                   [(ngModel)]="user.Username" name="username"
                                   #username="ngModel"
                                   [ngClass]="{
                    'form-error': !(username.valid || username.pristine),
                    'form-success': username.valid
                 }">
                            <i class="icon-user"></i>
                            <div [hidden]="username.valid || username.pristine"
                                 class="form-error valid">
                                L'username è richiesto
                            </div>
                        </div>

                        <div class="append-icon password-field" style="margin-top: 10px; margin-bottom: 20px;">
                            <input [type]="showPassword ? 'text' : 'password'" class="form-control input-lg" id="password"
                                   required placeholder="Password"
                                   [(ngModel)]="user.Password" name="password"
                                   #password="ngModel"
                                   [ngClass]="{
                    'form-error': !(password.valid || password.pristine),
                    'form-success': password.valid
                 }">
                            <i class="icon-lock"></i>
                            <button type="button"
                                    class="password-toggle"
                                    (mousedown)="$event.preventDefault()"
                                    (click)="showPassword = !showPassword"
                                    [attr.aria-pressed]="showPassword"
                                    [attr.aria-label]="showPassword ? 'Nascondi password' : 'Mostra password'">
                                <i class="fa" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword" aria-hidden="true"></i>
                            </button>
                            <div [hidden]="password.valid || password.pristine"
                                 class="alert alert-danger">
                                La password è richiesta
                            </div>
                        </div>

                        <button type="submit" class="btn btn-lg btn-rounded btn-primary btn-block ladda-button"
                                [disabled]="!loginForm.form.valid">Accedi</button>

                        <div [hidden]="!signInFailed" class="alert alert-danger">
                            Username e/o password errati.
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
